var _rect, _circle, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIdentLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 36,
    height: 24,
    rx: 3,
    stroke: "#4b5563",
    strokeWidth: 2.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 21,
    r: 4,
    stroke: "#4b5563",
    strokeWidth: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 31.5c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5",
    stroke: "#4b5563",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 20,
    x2: 37,
    y2: 20,
    stroke: "#4b5563",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 25,
    x2: 37,
    y2: 25,
    stroke: "#4b5563",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 30,
    x2: 33,
    y2: 30,
    stroke: "#4b5563",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIdentLogoNoText);
export default __webpack_public_path__ + "static/media/PhotoIdentLogoNoText.3fafedb34945786e4072cc4059473885.svg";
export { ForwardRef as ReactComponent };